/* file description */
export const ROUTERSTATUSMAPPING = {
  create: 'add',
  edit: 'edit',
  detail: 'view',
  list: 'list',
};
